import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import TextField from 'components/TextField/TextField';
import { INTERNAL_LIAISON, INTERNAL_LIAISON_EMAIL } from 'constants/formFields';

import type IRowLiaison from '../interfaces/IRowLiaison';

import styles from '../scss/CreateMedia.module.scss';

function RowLiaison({
  control,
}: IRowLiaison) {
  const { t } = useTranslation();
  return (
    <>
      <div className={styles.lColumn}>
        <Controller
          control={control}
          name={INTERNAL_LIAISON}
          render={({
            field: {
              name,
              value,
              onChange,
            },
            fieldState: { error },
          }) => (
            <TextField
              name={name}
              value={value}
              label={t('materialityAssessment.fields.internalLiaison')}
              error={error?.message}
              onChange={(event) => onChange(event.target.value)}
              placeholder={t('materialityAssessment.placeholder.typeHere')}
              required
            />
          )}
        />
      </div>
      <div className={styles.rColumn}>
        <Controller
          control={control}
          name={INTERNAL_LIAISON_EMAIL}
          render={({
            field: {
              name,
              value,
              onChange,
            },
            fieldState: { error },
          }) => (
            <TextField
              name={name}
              value={value}
              label={t('materialityAssessment.fields.internalLiaisonEmail')}
              error={error?.message}
              onChange={(event) => onChange(event.target.value)}
              placeholder={t('materialityAssessment.placeholder.typeHere')}
              required
            />
          )}
        />
      </div>
    </>
  );
}

export default RowLiaison;
